/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Pageable } from '../../models/pageable';
import { PagedModelProductMappingResponse } from '../../models/paged-model-product-mapping-response';

export interface GetProductMappings$Params {
  merchantId?: string;
  pageable: Pageable;
}

export function getProductMappings(http: HttpClient, rootUrl: string, params: GetProductMappings$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProductMappingResponse>> {
  const rb = new RequestBuilder(rootUrl, getProductMappings.PATH, 'get');
  if (params) {
    rb.query('merchantId', params.merchantId, {});
    rb.query('pageable', params.pageable, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PagedModelProductMappingResponse>;
    })
  );
}

getProductMappings.PATH = '/product-mappings';
